import cookie from 'react-cookies';

// With cookies fallback
class LocalStorageHelper {
  // store data
  static storeData(key, data) {
    const lsSupport = LocalStorageHelper.hasLocalStorageSupport();
    if (lsSupport) {
      // Native support
      const dataJson = JSON.stringify(data);
      localStorage.setItem(key, dataJson);
    } else {
      // Use Cookie
      cookie.save(key, data, { path: '/' });
    }
  }

  static storeCookie(key, data, hsTtl) {
    const expDate = new Date();
    expDate.setHours(expDate.getHours() + hsTtl);
    cookie.save(key, data, { path: '/', expires: expDate });
  }

  static getCookie(key) {
    let item = null;
    item = cookie.load(key);
    if (!item || item === 'undefined') {
      return null;
    }

    return item;
  }

  // get data
  static getData(key) {
    let item = null;

    const lsSupport = LocalStorageHelper.hasLocalStorageSupport();
    if (lsSupport) {
      try {
        // Native support
        const itemStr = localStorage.getItem(key);
        item = JSON.parse(itemStr);
      } catch (err) {
        return localStorage.getItem(key);
      }
    } else {
      // Use Cookie
      item = cookie.load(key);
    }

    if (!item || item === 'undefined') {
      return null;
    }

    return item;
  }

  // remove data
  static removeData(key) {
    const lsSupport = LocalStorageHelper.hasLocalStorageSupport();
    if (lsSupport) {
      // Native support
      localStorage.removeItem(key);
    } else {
      // Use Cookie
      cookie.remove(key, { path: '/' });
    }
  }

  static hasLocalStorageSupport() {
    let lsSupport = false;

    // Check for native support
    if (localStorage) {
      lsSupport = true;
    }

    return lsSupport;
  }
}

export default LocalStorageHelper;
